import { c as _c } from "react/compiler-runtime";
import { CollectSelfie } from '@onefootprint/idv2';
import { DocumentRequestKind, type DocumentRequirement, DocumentUploadSettings, type IdDocRequirementConfig } from '@onefootprint/types';
import { type ComponentProps, useEffect } from 'react';
import { trackAction } from '@/idv/utils';
import DeviceNotSupportedError from './components/device-not-supported-error';
import IdDoc from './id-doc';
import NonIdDoc from './non-id-doc';
import type { IdDocProps } from './types';
import { isMobileKind } from './utils/capture';
const CollectDocument = t0 => {
  const $ = _c(33);
  const {
    idvContext,
    context,
    onDone
  } = t0;
  const {
    authToken,
    device
  } = idvContext;
  const {
    requirement,
    sandboxOutcome,
    config
  } = context;
  let t1;
  if ($[0] !== authToken || $[1] !== config || $[2] !== device) {
    t1 = {
      authToken,
      device,
      config
    };
    $[0] = authToken;
    $[1] = config;
    $[2] = device;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const initialContext = t1;
  const requireMobileCapture = requirement.uploadSettings === DocumentUploadSettings.requireMobileCapture;
  const showDeviceError = requireMobileCapture && !isMobileKind(device.type);
  let t2;
  if ($[4] !== onDone || $[5] !== requirement.config.kind) {
    t2 = () => {
      trackAction("doc:completed", {
        kind: requirement.config.kind
      });
      onDone();
    };
    $[4] = onDone;
    $[5] = requirement.config.kind;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleFlowCompletion = t2;
  let t3;
  if ($[7] !== requirement.config.kind) {
    t3 = () => {
      trackAction("doc:started", {
        kind: requirement.config.kind
      });
    };
    $[7] = requirement.config.kind;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  if (showDeviceError) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <DeviceNotSupportedError />;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  if (isIdDocRequirement(requirement)) {
    let t5;
    if ($[11] !== initialContext || $[12] !== requirement || $[13] !== sandboxOutcome) {
      t5 = {
        ...initialContext,
        sandboxOutcome,
        requirement
      };
      $[11] = initialContext;
      $[12] = requirement;
      $[13] = sandboxOutcome;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] !== handleFlowCompletion || $[16] !== requirement.documentRequestId || $[17] !== t5) {
      t6 = <IdDoc key={requirement.documentRequestId} initialContext={t5} onDone={handleFlowCompletion} />;
      $[15] = handleFlowCompletion;
      $[16] = requirement.documentRequestId;
      $[17] = t5;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    return t6;
  }
  if (requirement.config.kind as string === "selfie") {
    let t5;
    if ($[19] !== authToken || $[20] !== config || $[21] !== device || $[22] !== handleFlowCompletion || $[23] !== requirement) {
      t5 = {
        authToken,
        device,
        requirement,
        onboardingConfig: config,
        onDone: handleFlowCompletion
      };
      $[19] = authToken;
      $[20] = config;
      $[21] = device;
      $[22] = handleFlowCompletion;
      $[23] = requirement;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    const selfieProps = t5 as unknown as ComponentProps<typeof CollectSelfie>;
    let t6;
    if ($[25] !== selfieProps) {
      t6 = <CollectSelfie {...selfieProps} />;
      $[25] = selfieProps;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    return t6;
  }
  let t5;
  if ($[27] !== initialContext || $[28] !== requirement) {
    t5 = {
      ...initialContext,
      requirement
    };
    $[27] = initialContext;
    $[28] = requirement;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== handleFlowCompletion || $[31] !== t5) {
    t6 = <NonIdDoc initialContext={t5} onDone={handleFlowCompletion} />;
    $[30] = handleFlowCompletion;
    $[31] = t5;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  return t6;
};
const isIdDocRequirement = (requirement: DocumentRequirement): requirement is DocumentRequirement<IdDocRequirementConfig> => requirement.config.kind === DocumentRequestKind.Identity;
export default CollectDocument;